import SeatReminderModal from '~/components/fragments/dialogs/seat-reminder.vue';
import { shouldShowSeatReminder } from '#shared/utilities/schedule/seat-reminder';

// After adding a session to My Schedule, surface the "you'll need to save a seat
// later" modal when the session is limited-capacity AND My Schedule is live but
// Save a Seat isn't open yet (see shouldShowSeatReminder).
export const useSeatReminder = () => {
    const { open } = useModal();
    const { showMySchedule, showSeatReservations } = useScheduleControls();

    const maybeShowAfterAdd = (session) => {
        if (shouldShowSeatReminder(session, showMySchedule.value, showSeatReservations.value)) {
            open(SeatReminderModal, { session });
        }
    };

    return { maybeShowAfterAdd };
};
